const runtimeConfig = typeof window !== 'undefined' && window.__9JAWIN_CONFIG__ && typeof window.__9JAWIN_CONFIG__ === 'object'
  ? window.__9JAWIN_CONFIG__
  : {};

export const getApiUrl = () => runtimeConfig.apiUrl || process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
export const getSocketUrl = () => runtimeConfig.socketUrl || process.env.REACT_APP_SOCKET_URL || window.location.origin;
